export default (setRemoveData, handleOpen) => (modelRemoveFunc, modelId, childId) => {
  setRemoveData(modelRemoveFunc(modelId, childId));
  handleOpen();
};
